"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskProductList = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../../../../__generated__/graphql");
const react_redux_1 = require("react-redux");
const client_utils_1 = require("../../../../../client/client.utils");
const table_columns_1 = require("../../../../../common/table-columns");
const table_pagination_1 = require("../../../../../common/table-pagination");
const attributes_1 = require("../../../../../constants/attributes");
const hooks_1 = require("../../../../../preview-products-widget/preview-products-widget-content/hooks");
const task_view_1 = require("../../../../../store/catalogs/task-view");
const store_1 = require("../../../../../../store");
const TASK_PRODUCT_LIST_ROW_CHUNK_SIZE = 250;
const useTaskProductList = ({ attributeColumnId, labelsSelection, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const tableSort = (0, task_view_1.useTaskViewProductsTableSortOrDefault)();
    const tableFilter = (0, task_view_1.useTaskViewProductsTableFilter)();
    const searchTerm = (0, task_view_1.useTaskViewProductsTableSearch)();
    const pageSize = (0, task_view_1.useTaskViewProductsTablePageSize)();
    const persistedState = (0, react_1.useMemo)(() => ({ pageSize }), [pageSize]);
    const initialModel = (0, react_1.useMemo)(() => ({ page: 0, pageSize }), [pageSize]);
    const setPersistedState = (paginationModel) => {
        if (paginationModel.pageSize !== pageSize) {
            dispatch((0, task_view_1.setTaskViewTablePageSize)(catalogId, paginationModel.pageSize));
        }
    };
    const taskViewProductTreeNodeId = (0, task_view_1.useTaskViewProductsTableSelectedTreeNodeId)();
    const { label: attributeName, dataMeta: { isMeasure } } = (0, react_1.useMemo)(() => (0, table_columns_1.parseColumnId)(attributeColumnId), [attributeColumnId]);
    const { products, isLoading, networkStatus, totalCount, refetch, pageInfo, error, chunkLoadError, chunkLoadErrorProductCount, canRetryChunkLoad, retryChunkLoad, lastVariables, isPageRowsSyncing, arePageRowsIncomplete, } = (0, hooks_1.useProducts)({
        tableFilter,
        tableSort,
        searchTerm,
        isListViewMode: true,
        labelsSelection,
        reviewStatus: {
            attribute: attributeName,
            attributeType: attributeName === attributes_1.CustomProductAttributes.ClassificationProductType
                ? graphql_1.ProductAttributeType.Category
                : isMeasure
                    ? graphql_1.ProductAttributeType.Measure
                    : graphql_1.ProductAttributeType.Label,
        },
        productTreeNodeId: taskViewProductTreeNodeId,
        pageSize,
        chunkSize: TASK_PRODUCT_LIST_ROW_CHUNK_SIZE,
        includeLabelExplanation: true,
        // HLQA tasks are always scoped to terminal nodes, so keep label validation enabled
        // to consistently map missing strategy values to Unknown in the table parser.
        skipLabelValidation: false,
    });
    const { isPaginationRefetching, paginationRefetch, } = (0, table_pagination_1.usePaginationRefetch)({ refetch });
    const { paginationModel, onPaginationModelChange, } = (0, table_pagination_1.useOffsetCursorPaginationAdapter)({
        refetch: paginationRefetch,
        totalCount,
        startCursor: pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.startCursor,
        initialModel,
        persistedState,
        setPersistedState,
    });
    return {
        products,
        // Show the loader for the initial load and variable changes (sort/filter/search), but not for
        // refetch (e.g. refetchProductList after a mutation), which should keep the current rows visible.
        // Pagination also uses refetch under the hood, so keep a local flag for user-triggered page changes.
        isLoading: (isLoading && !(0, client_utils_1.isQueryRefetching)(networkStatus)) || isPaginationRefetching,
        isPageRowsSyncing,
        arePageRowsIncomplete,
        refetchProductList: refetch,
        paginationModel,
        onPaginationModelChange,
        networkStatus,
        error,
        chunkLoadError,
        chunkLoadErrorProductCount,
        canRetryChunkLoad,
        retryChunkLoad,
        totalCount,
        lastVariables: lastVariables,
    };
};
exports.useTaskProductList = useTaskProductList;
